export var TEXT_COLOR = '#252525';
export var TRANSPARENT_COLOR = '#FFFFFF';
